
const gtag = window.gtag ? window.gtag : () => { console.warn("NO GTAG AVAILABLE")};

export const sendEvent = (action, data) => {
    //ACTION: "click"
    // data: { value: "click_register_button" }
    gtag("event", action, data);
}
